module.exports = __webpack_public_path__ + "static/media/mb-sword.071d392d.gif";